import { Injectable } from '@angular/core';
import { VideoItemComponent } from './video-item.component';

@Injectable({
    providedIn: 'root',
})
export class VideoItemService {
    private _videos: VideoItemComponent[] = [];

    get count(): number {
        return this._videos.length;
    }

    addVideo(video: VideoItemComponent): number {
        this._videos.push(video);

        return this._videos.length - 1;
    }

    removeVideo(index: number) {
        this._videos.splice(index, 1);
    }

    pauseAll() {
        this._videos.forEach((x: VideoItemComponent) => {
            if (x.isPlaying()) x.player?.pause();
        });
    }
}
